import { fetch } from '@ixigo/shell/fetch';

import type { ManagePaymentsResponse } from '../types';

export function fetchManagePayments(options?: {
	signal?: AbortSignal;
}): Promise<ManagePaymentsResponse> {
	return fetch.get('payments/v10/manage-payment-options', options).json();
}
